import { useState } from "react";
import { signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth, Providers } from "../../config/firebase";
import { Box, Button, Typography, Link, Container } from '@mui/material';
import AppleIcon from '@mui/icons-material/Apple';
import GoogleIcon from '@mui/icons-material/Google';
import DGVMetricsLogo from "../images/DGVMetricsLogo";
import DGVLogo from "../images/DGVLogo";
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://spinoffgames.se/">
                Spinoff Games AB
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

interface Props { }

const AuthContainer = (props: Props) => {
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const [disabled, setDisabled] = useState(false);
    const originalUrl = sessionStorage.getItem('originalUrl');

    const signInWithGoogle = () => {
        setDisabled(true);
        signInWithPopup(auth, Providers.google).then(() => {
            setDisabled(false);
            let originalUrl = sessionStorage.getItem('originalUrl') || "/";
            if (originalUrl === "/login") {
                originalUrl = "/"; // or another default page
            }
            // console.info("TODO: navigate to authenticated screen");
            navigate(originalUrl);
        }).catch((error) => {
            setErrorMessage(error.code + ": " + error.message);
            setDisabled(false);
        });
    };

    const signInWithApple = () => {
        setDisabled(true);
        signInWithPopup(auth, Providers.apple).then(() => {
            setDisabled(false);
            let originalUrl = sessionStorage.getItem('originalUrl') || "/";
            if (originalUrl === "/login") {
                originalUrl = "/"; // or another default page
            }
            // console.info("TODO: navigate to authenticated screen");
            navigate(originalUrl);
        }).catch((error) => {
            setErrorMessage(error.code + ": " + error.message);
            setDisabled(false);
        });
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: { xs: 8, sm: 6, md: 10 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                {originalUrl === '/deleteaccount' ? <DGVLogo topNavLogo={false}/> : <DGVMetricsLogo topNavLogo={false}/>}

                <Typography component="h1" variant="h5">
                    Sign in
                </Typography>
                <Box
                    sx={{
                        mt: 1,
                        display: 'inline-flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Button
                        disabled={disabled}
                        onClick={signInWithGoogle}
                        style={{ maxWidth: '180px', maxHeight: '44px', minWidth: '180px', minHeight: '44px' }}
                        // fullWidth
                        size="medium"
                        variant="contained"
                        startIcon={<GoogleIcon />}
                        sx={{ mt: 2, mb: 0 }}
                    >
                        Google
                    </Button>
                    <Button
                        disabled={disabled}
                        onClick={signInWithApple}
                        style={{ maxWidth: '180px', maxHeight: '44px', minWidth: '180px', minHeight: '44px' }}
                        // fullWidth
                        size="medium"
                        variant="contained"
                        startIcon={<AppleIcon />}
                        sx={{ mt: 2, mb: 0 }}
                    >
                        Apple
                    </Button>
                </Box>
            </Box>
            <Copyright sx={{ mt: 6, mb: 1 }} />
        </Container>
    );
};

export default AuthContainer;
